import moment from "moment";
import "moment/locale/fr";
import "moment/locale/nl";

// import CreditCardIcon from "./assets/credit-card.svg";
// import DownloadIcon from "./assets/download.svg";
import styles from "./Invoices.module.scss";
import { TTP_BILLING_URL, S3_FOLDER_URL } from "../../config";
import _ from "../../i18n";

// export const ACTION_ICONS = {
//   download: <DownloadIcon />,
//   pay: <CreditCardIcon />,
// };

function Invoice({ order, creditNote, language }) {
  const { color, date, description, paymentMethod, amount, status, action } =
    getDocumentData(order, creditNote, language);

  return (
    <tr className={styles.item} data-id={order.id}>
      <td className={styles.date} style={{ boxShadow: `-2px 0 0 ${color}` }}>
        {date} - {order.id}
      </td>
      <td className={styles.description}>{description}</td>
      <td className={styles.paymentMethod}>{paymentMethod}</td>
      <td className={styles.amount}>{amount}</td>
      <td className={styles.status}>
        {(({ label, showBullet }) => (
          <div>
            {showBullet && (
              <span
                className={styles.bullet}
                style={{ backgroundColor: color }}
              />
            )}
            <span className={styles.label}>{label}</span>
          </div>
        ))(status)}
      </td>
      <td className={styles.action}>
        {action
          ? (({ label, icon, ...restProps }) => (
              <a className={styles.button} {...restProps}>
                {/* {ACTION_ICONS[icon]} */}
                {label}
              </a>
            ))(action)
          : null}
      </td>
    </tr>
  );
}

export default Invoice;

const CreditNoteStatus = {
  NOT_REFUNDED: "NOT_REFUNDED",
  REFUNDED: "REFUNDED",
};

const OrderStatus = {
  OVER_PAID: "OVER_PAID",
  PAID: "PAID",
  NOT_PAID: "NOT_PAID",
  UNDER_PAID: "UNDER_PAID",
};

const OrderOperationType = {
  BANK_TRANSFER: "BANK_TRANSFER",
  MANUAL: "MANUAL",
  OGONE: "OGONE",
  PAYPAL: "PAYPAL",
  MANGO_PAY: "MANGO_PAY",
  PAY_CONIQ: "PAY_CONIQ",
};

export const getInvoiceData = (order, creditNote, language) => {
  const isPaid = [OrderStatus.PAID, OrderStatus.OVER_PAID].includes(
    order.status
  );
  const assignments =
    order.assignments?.filter(
      (assignment) => assignment.operationType !== OrderOperationType.MANUAL
    ) ?? [];
  const assignment = last(assignments);
  const price = order.includingVatAmount / 100;
  const isFree = price === 0 && !assignment;

  const date = ((order, assignment, creditNote) => {
    if (creditNote) {
      return moment(creditNote.documentDate).locale(language).format("lll");
    }

    if (assignment) {
      return moment
        .utc(assignment.dateTimeAssignment)
        .local()
        .locale(language)
        .format("lll");
    }

    return moment(order.documentDate).locale(language).format("lll");
  })(order, isPaid ? assignment : undefined, creditNote);

  const action = ((order, isPaid, assignment) => {
    if (isPaid) {
      if (
        !assignment &&
        (!order.forcedRegistrationType ||
          order.forcedRegistrationType !== "FORCED")
      ) {
        return null;
      }
      const pdfPath = order.invoice?.pdfPath;

      if (!pdfPath) {
        return null;
      }

      return {
        target: "_blank",
        rel: "noopener noreferrer",
        href: `${S3_FOLDER_URL}/${pdfPath}`,
        download: true,
        label: "Télécharger la facture",
        icon: "download",
      };
    }

    return null;
  })(order, isPaid, assignment);

  return {
    color: isPaid ? "#06D9B1" : "#FE3745",
    date,
    description: order.comment,
    paymentMethod: assignment ? getPaymentMethod(assignment) : "_",
    amount: `${price.toFixed(2)}€`,
    status: {
      label: isFree
        ? "_"
        : isPaid
          ? "Paiement effectué"
          : "Paiement non effectué",
      showBullet: !isFree,
    },
    action,
  };
};

export const getCreditNoteData = (creditNote, language) => {
  const { isCompensated } = creditNote;
  const isRefunded = creditNote.status == CreditNoteStatus.REFUNDED;

  const action = (() => {
    const { pdfPath } = creditNote;

    if (isEmpty(pdfPath)) {
      return null;
    }

    return {
      target: "_blank",
      rel: "noopener noreferrer",
      href: `${S3_FOLDER_URL}/${pdfPath}`,
      download: true,
      label: _("document.downloadCreditNote"),
      icon: "download",
    };
  })();

  return {
    color: "#6d7f92",
    date: moment(creditNote.documentDate).locale(language).format("lll"),
    description: creditNote.comment,
    paymentMethod: "_",
    amount: `${creditNote.includingVatAmount / 100}€`,
    status: {
      label: isCompensated
        ? _("document.compensationMade")
        : isRefunded
          ? _("document.refundMade")
          : _("document.refundNotMade"),
      showBullet: true,
    },
    action,
  };
};

const getDocumentData = (order, creditNote, language) => {
  if (creditNote) {
    return getCreditNoteData(creditNote, language);
  }

  return getInvoiceData(order, creditNote, language);
};

const last = (array) => {
  if (array == null || array.length === 0) {
    return undefined;
  }
  return array[array.length - 1];
};

const getPaymentMethod = (assignement) => {
  if (["OGONE", "PAYPAL", "MANGO_PAY"].includes(assignement.operationType)) {
    return "Paiement en ligne";
  }

  if (["BANK_TRANSFER"].includes(assignement.operationType)) {
    return "Virement bancaire";
  }

  if (["PAY_CONIQ"].includes(assignement.operationType)) {
    return "Payconiq";
  }

  return assignement.operationType;
};
